export default "__VITE_ASSET__DLPNpQD5__"